import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycHowIsAWillContestedInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-how-is-a-will-contested-in-new-york/']} />;
}
